import { HyrinWordmark } from '@/components/Shared/HyrinWordmark'

interface FooterColumn {
  heading: string
  items: string[]
}

const FOOTER_COLUMNS: FooterColumn[] = [
  {
    heading: 'Company',
    items: ['Legal', 'Privacy'],
  },
  {
    heading: 'Data usage',
    items: ['AI policy', 'GDPR'],
  },
  {
    heading: 'Comparison',
    items: ['LinkedIn vs Hyrin'],
  },
]

export function PublicFooter() {
  return (
    <footer className="border-t border-border bg-muted px-5 py-14 sm:px-10">
      <div className="mx-auto max-w-[1100px]">
        <div className="grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-3">
          {FOOTER_COLUMNS.map((column) => (
            <div key={column.heading}>
              <p className="mb-4 font-mono text-[11px] uppercase tracking-eyebrow text-muted-foreground">
                {column.heading}
              </p>
              <ul className="flex flex-col gap-[10px]">
                {column.items.map((item) => (
                  <li key={item} className="font-sans text-[14px] text-foreground">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col gap-4 border-t border-border pt-6 sm:flex-row sm:items-center sm:justify-between">
          <a href="/" className="flex items-center gap-2">
            <HyrinWordmark />
          </a>
          <p className="font-mono text-[11px] uppercase tracking-[0.08em] text-muted-foreground">
            © 2026 Hyrin. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
